const dataConfig = {
  localSet : {
    "separator": " - ",
    "applyLabel": "ตกลง",
    "cancelLabel": "ยกเลิก",
    "fromLabel": "จาก",
    "toLabel": "ถึง",
    "monthNames": [  "มกราคม", "กุมภาพันธ์", "มีนาคม",  "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม" ],
    "daysOfWeek": ['อา','จ','อ','พ','พฤ','ศ','ส']
  },
}

export default dataConfig;
